export default function BrandMark({ tone = "ink" }) {
  const color = tone === "light" ? "#FFFBF5" : "#1F1A17";
  return (
    <div className="flex items-center gap-2">
      <svg width="36" height="36" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <path
          d="M32 8c8 0 16 6 16 16 0 10-10 18-16 26C26 42 16 34 16 24c0-10 8-16 16-16Z"
          fill="#C86A4A"
          opacity="0.92"
        />
        <path
          d="M22 26c4 0 6-2 10-2s6 2 10 2"
          stroke="#FFFBF5"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
        <circle cx="32" cy="22" r="2.2" fill="#FFFBF5" />
      </svg>
      <div className="leading-tight">
        <div
          className="font-display text-base sm:text-lg lg:text-xl tracking-tight whitespace-nowrap"
          style={{ color }}
        >
          The Human Work Project
        </div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-ink-muted">
          Understand. Grow. Thrive.
        </div>
      </div>
    </div>
  );
}
